import { getTags } from "actions";
import { createAlert } from "actions/alerts";
import { fetchMany } from "actions/resources";
import { getResponses } from "actions/responses";
import keyConverter from "services/key-converter";

export function closeModal() {
  return {
    type: "SET_MODAL",
    payload: { isOpen: false, view: null, size: null }
  };
}

export function addGreeting(greeting) {
  const newGreeting = keyConverter(greeting, "underscore");

  return [
    {
      CALL_API: {
        method: "post",
        endpoint: "/intros/",
        payload: {
          response_id: newGreeting.response_id,
          delay: newGreeting.delay,
          duration: newGreeting.duration,
          style: newGreeting.style,
          body: newGreeting.body,
          paths: newGreeting.paths
        },
        types: [
          "CREATE_GREETING_REQUEST",
          "CREATE_GREETING_SUCCESS",
          "CREATE_GREETING_FAILURE"
        ],
        dispatchCallbacks: [
          {
            request: closeModal,
            fireOnStatus: "success"
          },
          {
            request: createAlert,
            fireOnStatus: 400,
            args: {
              message: "Sorry, one (or more) of those paths are assigned to another Intro",
              alertType: "warning"
            }
          },
          {
            request: createAlert,
            fireOnStatus: "success",
            args: {
              message: "Your Intro was successfully published!",
              alertType: "success"
            }
          }
        ]
      }
    },
    {
      type: "RESET_NEW_GREETING"
    }
  ];
}

export function initializeGreetings() {
  return {
    type: "INITIALIZE_GREETINGS"
  };
}

export function getGreetings() {
  return {
    CALL_API: {
      method: "get",
      endpoint: "/intros/",
      types: [
        "GET_GREETINGS_REQUEST",
        "GET_GREETINGS_SUCCESS",
        "GET_GREETINGS_FAILURE"
      ]
    }
  };
}

export function updateGreetingConfig(greetingId, parameter, value, key = null) {
  return {
    type: "UPDATE_GREETING",
    greetingId,
    parameter,
    value,
    key
  };
}

export function updateGreetingMessage(greetingId, value, key) {
  return {
    type: "UPDATE_GREETING_BODY",
    greetingId,
    value,
    key
  };
}

export function updateEmoji(greetingId, value) {
  return {
    type: "UPDATE_GREETING_EMOJI",
    greetingId,
    value
  };
}

export function addGreetingPath(greetingId, value) {
  return {
    type: "ADD_PATH",
    greetingId,
    value
  };
}

export function deleteGreetingPath(greetingId, key) {
  return {
    type: "DELETE_PATH",
    greetingId,
    key
  };
}

export function deleteLanguage(greetingId, key, primaryLanguage) {
  return {
    type: "DELETE_LANGUAGE_GREETING",
    greetingId,
    key,
    primaryLanguage
  };
}

export function undoGreeting(greetingId) {
  return {
    type: "UNDO_GREETING",
    greetingId
  };
}

export function publishGreeting(greeting) {
  const newGreeting = keyConverter(greeting, "underscore");

  return {
    CALL_API: {
      method: "patch",
      endpoint: `/intros/${greeting.id}`,
      args: [greeting],
      payload:
      {
        response_id: newGreeting.response_id,
        delay: newGreeting.delay,
        duration: newGreeting.duration,
        style: newGreeting.style,
        body: newGreeting.body,
        paths: newGreeting.paths
      },
      types: [
        "UPDATE_GREETINGS_REQUEST",
        "UPDATE_GREETINGS_SUCCESS",
        "UPDATE_GREETINGS_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: closeModal,
          fireOnStatus: "success"
        },
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: "Intro has been updated.",
            alertType: "success"
          }
        },
        {
          request: createAlert,
          fireOnStatus: 400,
          args: {
            message: "Sorry, one (or more) of those paths are assigned to another Intro",
            alertType: "warning"
          }
        }
      ]
    }
  };
}

export function deleteGreeting(greetingId) {
  return {
    CALL_API: {
      method: "delete",
      endpoint: `/intros/${greetingId}`,
      args: {
        greetingId
      },
      types: [
        "DELETE_GREETING_REQUEST",
        "DELETE_GREETING_SUCCESS",
        "DELETE_GREETING_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: "Intro has been successfully deleted.",
            alertType: "success"
          }
        }
      ]
    }
  };
}

export function getAllIntrosData() {
  return dispatch => Promise.all([
    dispatch(fetchMany("language")),
    dispatch(getResponses()),
    dispatch(getTags()),
    dispatch(initializeGreetings()),
    dispatch(getGreetings())
  ]);
}
